import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreateQuickVendorLookupComponent } from '../create-quick-vendor-lookup/create-quick-vendor-lookup.component';

@Component({
  selector: 'app-close-quick-vendor-lookup',
  standalone: true,
  imports: [CreateQuickVendorLookupComponent],
  templateUrl: './close-quick-vendor-lookup.component.html',
  styleUrl: './close-quick-vendor-lookup.component.scss'
})
export class CloseQuickVendorLookupComponent {

  constructor(public ref: DynamicDialogRef){}

  close(data: any){
    this.ref.close(data);
  }

}
